module.exports = __webpack_public_path__ + "img/océane.04243b7.jpeg";